import styled from 'styled-components';
import { DEVICES } from '../../config/appConfig';

export const Container = styled.div`
  width: 100%;
  position: relative;
  /* display: grid;
  grid-template-columns: ${({ gridValue }) => `repeat(${6}, 1fr)`}; */
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  max-width: 1400px;
  margin: 0 auto;

  @media ${DEVICES.tablet} {
    display: flex;
    align-self: center;
    width: 100%;
    flex-wrap: wrap;

    ${({ gridValue }) =>
      gridValue === 6 || gridValue === 4
        ? `
    & > div:nth-child(1) {
      margin-left: calc(100% / 7);
    }
  `
        : `
    & > div:nth-child(1) {
      margin-left: 0px;
    }
  `}
    & > div:nth-child(-n + 3) {
      width: calc(100% / 3.5);
      gap: 0px;
      display: flex;
      justify-content: flex-end;
      align-self: flex-end;
      align-items: flex-end;
      align-content: flex-end;
    }
    ${({ gridValue }) =>
      gridValue === 6 || gridValue === 4
        ? `
    & > div:nth-child(4) {
      margin-left: calc(100% / -7);
    }
  `
        : `
    & > div:nth-child(4) {
      margin-left: 0px;
    }
  `}
    & > div:nth-child(n + 4):nth-child(-n + 6) {
      width: calc(100% / 3.5);
      gap: 0px;
      display: flex;
      justify-content: flex-end;
      align-self: flex-end;
      align-items: flex-end;
      align-content: flex-end;
      margin-top: calc(-5.6vw);
    }
  }

  @media ${DEVICES.mobile} {
    display: flex;
    align-self: center;
    width: 100%;
    flex-wrap: wrap;

    ${({ gridValue }) =>
      gridValue === 6 || gridValue === 4
        ? `
    & > div:nth-child(1) {
      margin-left: calc(100% / 7);
    }
  `
        : `
    & > div:nth-child(1) {
      margin-left: 0px;
    }
  `}
    & > div:nth-child(-n + 3) {
      width: calc(100% / 3.5);
      gap: 0px;
      display: flex;
      justify-content: flex-end;
      align-self: flex-end;
      align-items: flex-end;
      align-content: flex-end;
    }
    ${({ gridValue }) =>
      gridValue === 6 || gridValue === 4
        ? `
    & > div:nth-child(4) {
      margin-left: calc(100% / -7);
    }
  `
        : `
    & > div:nth-child(4) {
      margin-left: 0px;
    }
  `}
    & > div:nth-child(n + 4):nth-child(-n + 6) {
      width: calc(100% / 3.5);
      gap: 0px;
      margin-top: calc(-6.6vw);
    }
  }

  @media ${DEVICES.sMobile} {
    display: flex;
    align-self: center;
    width: 100%;
    flex-wrap: wrap;

    ${({ gridValue }) =>
      gridValue === 6 || gridValue === 4
        ? `
    & > div:nth-child(1) {
      margin-left: calc(100% / 7);
    }
  `
        : `
    & > div:nth-child(1) {
      margin-left: 0px;
    }
  `}

    & > div:nth-child(-n + 3) {
      width: calc(100% / 3.5);
      gap: 0px;
      display: flex;
      justify-content: flex-end;
      align-self: flex-end;
      align-items: flex-end;
      align-content: flex-end;
    }

    ${({ gridValue }) =>
      gridValue === 6 || gridValue === 4
        ? `
    & > div:nth-child(4) {
      margin-left: calc(100% / -7);
    }
  `
        : `
    & > div:nth-child(4) {
      margin-left: 0px;
    }
  `}

    & > div:nth-child(n + 4):nth-child(-n + 6) {
      width: calc(100% / 3.5);
      gap: 0px;
      margin-top: calc(-6.6vw);
    }
  }
`;

export const HexagonContainer = styled.div`
  position: relative;
  width: 200px;
  aspect-ratio: 1;
  background: linear-gradient(
    180deg,
    rgb(180, 90, 20) 0%,
    rgb(245, 130, 32) 50%,
    rgb(255, 220, 190) 70%,
    rgb(255, 245, 235) 100%
  );
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HexagonContent = styled.div`
  position: absolute;
  top: 1px;
  left: 1px;
  right: 1px;
  bottom: 1px;
  background: white;
  clip-path: inherit;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
  padding: 0px 12px 12px 12px;
  gap: 2px;
  .iconStyle {
    width: 42px;
    width: 42px;
  }
  .headingStyle {
    font-size: 22px;
    font-weight: bold;
    color: #333;
  }
  .subHeadingStyle {
    font-size: 14px;
    color: #666;
  }
  @media ${DEVICES.tablet} {
    .iconStyle {
      width: 38px;
      width: 38px;
    }
    .headingStyle {
      font-size: 22px;
    }
    .subHeadingStyle {
      font-size: 16px;
    }
  }
  @media ${DEVICES.mobile} {
    .iconStyle {
      width: 36px;
      width: 36px;
    }
    .headingStyle {
      font-size: 16px;
    }
    .subHeadingStyle {
      font-size: 13px;
    }
  }
  @media ${DEVICES.sMobile} {
    .iconStyle {
      width: 26px;
      width: 26px;
    }
    .headingStyle {
      font-size: 14px;
    }
    .subHeadingStyle {
      font-size: 9px;
    }
  }
  @media ${DEVICES.sSMobile} {
    .iconStyle {
      width: 18px;
      width: 18px;
    }
    .headingStyle {
      font-size: 11px;
    }
    .subHeadingStyle {
      font-size: 7px;
    }
  }
`;

export const ContainerStyled = styled.div`
  padding-bottom: 16px;
  padding-top: 16px;
`;
